import { api } from '@/lib/api-client';
import { GrantCreditRequest, GrantCreditResponse } from '@/types/credits';
import { useApiMutation } from './useApiMutation';

export function useGrantCreditsSecure() {
  return useApiMutation<GrantCreditResponse, GrantCreditRequest>((data: GrantCreditRequest) =>
    api.grantCreditsSecure(data),
  );
}
